export default __webpack_public_path__ + "static/media/site-page.f28a93e3.png";